<template>
  <div class="box">
    <div class="work">
      <!--路径 -->
      <div class="path">
        <img class="path_img" src="../../../../../assets/images/path.png"/>
        <div class="path_txt">运营管理系统 > 快应用报表 > 效果手工回传</div>
      </div>
      <!--查询条件-->
      <div class="condition">
        <div class="condi_line">
          <div class="condi_item">
            <div class="condi_item_label">回传日期:</div>
            <div class="condi_item_cnt">
              <el-date-picker
                      v-model="searchCondition.effectDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      value="yyyy-MM-dd"
                      placeholder="选择日期">
              </el-date-picker>
            </div>
          </div>

          <div class="condi_item">
            <div class="condi_item_label">时间范围:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.beforeHour" filterable  clearable  placeholder="请选择时间范围">
                <el-option
                        v-for="key in Object.keys(beforeHours)"
                        :key="key"
                        :label="beforeHours[key]"
                        :value="key">
                </el-option>
              </el-select>
            </div>
          </div>
          
          <div class="condi_item">
            <div class="condi_item_label">应用:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.appId" filterable  clearable  placeholder="请选择应用">
                <el-option
                        v-for="app in apps"
                        :key="parseInt(app.app_id)"
                        :label="'(' + app.app_id + ')' + app.app_name"
                        :value="parseInt(app.app_id)">
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="condi_item">
            <div class="condi_item_label">应用类型:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.appType" filterable  clearable  placeholder="请选择应用类型">
                <el-option
                        v-for="key in Object.keys(appTypes)"
                        :key="key"
                        :label="'(' + key + ')' + appTypes[key]"
                        :value="key">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="condi_line">
          <div class="condi_item">
            <div class="condi_item_label">渠道位置:</div>
            <div class="condi_item_cnt">
              <el-input v-model="searchCondition.channelSlotId" clearable placeholder="请输入渠道号" />
            </div>
          </div>
  
          <div class="condi_item">
            <div class="condi_item_label">用户ARPU:</div>
            <div class="condi_item_cnt">
              <el-input v-model="searchCondition.userArpu" clearable placeholder="用户最低ARPU值" />
            </div>
          </div>

          <div class="condi_item">
            <div class="condi_item_label">用户曝光:</div>
            <div class="condi_item_cnt">
              <el-input v-model="searchCondition.userView" clearable placeholder="用户最低曝光次数" />
            </div>
          </div>

          <div class="condi_item">
            <div class="condi_item_label">用户点击:</div>
            <div class="condi_item_cnt">
              <el-input v-model="searchCondition.userClick" clearable placeholder="用户最低点击次数" />
            </div>
          </div>
        </div>

        <div class="condi_line">
          <div class="condi_item">
            <div class="condi_item_label"></div>
            <div class="condi_item_cnt">
              <el-button type="primary" @click="onSearch">查询</el-button>
            </div>
          </div>
        </div>
      </div>
      <!--数据列表-->
      <div class="datalist">
        <div class="dtlst_top">
          <div class="dtlst_title">效果数据</div>
          <div class="dtlst_btn">
            <el-button @click="historyCallback">历史回传</el-button>
          </div>
        </div>
        <div class="dtlst_table">
          <el-table
            :data="effects"
            stripe
          >
            <el-table-column prop="effect_time" label="发生时间" width="200px">
              <template slot-scope="scope">{{scope.row.effect_time}}</template>
            </el-table-column>
            <el-table-column key="app_id" prop="app_id" label="应用" width="120px">
              <template slot-scope="scope">({{scope.row.app_id}}){{apps ? apps.find(item => item.app_id==scope.row.app_id).app_name : ''}}</template>
            </el-table-column>
            <el-table-column key="app_type" prop="app_type" label="应用类型" width="120px">
              <template slot-scope="scope">({{scope.row.app_type}}){{appTypes[scope.row.app_type]}}</template>
            </el-table-column>
            <el-table-column prop="user_id" label="用户ID" width="180px">
              <template slot-scope="scope">{{scope.row.user_id}}</template>
            </el-table-column>
            <el-table-column prop="session_id" label="会话ID" width="220px">
              <template slot-scope="scope">{{scope.row.session_id}}</template>
            </el-table-column>
            <el-table-column prop="channel_slot_id" width="120px" label="渠道号">
              <template slot-scope="scope">{{scope.row.channel_slot_id}}</template>
            </el-table-column>
            <el-table-column prop="user_arpu" width="120px" label="用户ARPU">
              <template slot-scope="scope">{{scope.row.user_arpu.toFixed(3)}}</template>
            </el-table-column>
            <el-table-column prop="user_arpu" width="120px" label="用户最高eCPM">
              <template slot-scope="scope">{{scope.row.user_ecpm.toFixed(2)}}</template>
            </el-table-column>
            <el-table-column prop="user_view" width="120px" label="曝光次数">
              <template slot-scope="scope">{{scope.row.user_view}}</template>
            </el-table-column>
            <el-table-column prop="user_click" width="120px" label="点击次数">
              <template slot-scope="scope">{{scope.row.user_click}}</template>
            </el-table-column>
             <el-table-column prop="user_duration" width="120px" label="访问时长">
              <template slot-scope="scope">{{scope.row.user_duration}}</template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <div class="dtlst_operation">
                  <el-button type="primary" size="small" @click="feedback(scope.row)">回传</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!--历史回传记录-->
      <el-dialog title="人工回传历史数据" 
        :visible.sync="dialogHistoryCallbackVisible" 
        :close-on-click-modal="false"
        width="1000px"
        center>
        
        <div class="dtlst_table">
          <el-table
            :data="historyEtasks.tableData"
            stripe
          >
            <el-table-column prop="create_time" label="时间" width="180px">
              <template slot-scope="scope">{{scope.row.create_time}}</template>
            </el-table-column>
            <el-table-column key="app_id" prop="app_id" label="应用" width="120px">
              <template slot-scope="scope">({{scope.row.app_id}}){{apps ? apps.find(item => item.app_id==scope.row.app_id).app_name : ''}}</template>
            </el-table-column>
            <el-table-column key="app_type" prop="app_type" label="应用类型" width="100px">
              <template slot-scope="scope">({{scope.row.app_type}}){{appTypes[scope.row.app_type]}}</template>
            </el-table-column>
            <el-table-column key="issue_platform_name" prop="issue_platform_name" label="平台" width="120px">
              <template slot-scope="scope">{{scope.row.issue_platform_name}}</template>
            </el-table-column>
            <el-table-column key="channel_id" prop="channel_id" label="渠道" width="120px">
              <template slot-scope="scope">({{scope.row.channel_id}}){{scope.row.channel_name}}</template>
            </el-table-column>
            <el-table-column prop="channel_slot_id" width="100px" label="渠道号">
              <template slot-scope="scope">{{scope.row.channel_slot_id}}</template>
            </el-table-column>
            <el-table-column prop="effect_require_count" width="160px" align="right" label="已回传/要求回传">
              <template slot-scope="scope">
                {{scope.row.effect_manual_count}} / {{scope.row.effect_require_count}}
              </template>
            </el-table-column>
          </el-table>
          <div class="dtlst_pagination">
            <el-select v-model="historyEtasks.dateRange" @change="loadHistoryCallback()" placeholder="请选择日志时间范围">
              <el-option
                v-for="item in logDateRange"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <el-pagination
              small
              background
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="historyEtasks.pageIndex"
              :page-size="historyEtasks.pageSize"
              :page-sizes="[100, 200, 500, 1000]" 
              :page-count="historyEtasks.pageCount"
              :total="historyEtasks.recordTotalCount"
              @current-change="changeOperateLogCurrPage"
              @size-change="changeOperateLogPageSize"
            >
            </el-pagination>
          </div>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      // 操作员对象
      operator: null,

      // 数据集合
      effects: null,
      
      // 搜索的参数
      searchCondition: {
        effectDate: null,     //效果日期
        beforeHour: 1,        //往前小时
        appId: null,          //应用ID
        appType: null,        //应用类型
        channelSlotId: null,  //渠道位置ID
        userArpu: null,       //用户ARPU
        userView: null,       //曝光
        userClick: null,      //点击
      },

      apps: null,             // 应用集合
      channels: null,         // 渠道列表
      
      // 应用类型
      appTypes: {
        5: "H5",
        61: "OPPO",
        62: "VIVO",
        63: "小米",
        65: "华为",
        66: "荣耀",
      },

      // 往前小时数
      beforeHours: {
        1: "往前1小时",
        2: "往前2小时",
        3: "往前3小时",
        4: "往前4小时",
        5: "往前5小时",
        6: "往前6小时",
        7: "往前7小时",
        8: "往前8小时",
        9: "往前9小时",
        10: "往前10小时",
      },

      /************历史回传记录**************/
      dialogHistoryCallbackVisible: false,
      historyEtasks: {
        dateRange: 0,
        pageIndex: 1,         // 当前页索引
        pageSize: 100,        // 本页显示数量
        pageCount: 1,         // 分页总数
        recordTotalCount: 0,  // 记录
        tableData: [],        // 应用列表数据
      },
      logDateRange: [{
          value: 0,
          label: '今天'
        },
        {
          value: 3,
          label: '最近3天'
        },
        {
          value: 7,
          label: '最近7天'
        },
        {
          value: 15,
          label: '最近15天'
        }
      ],
      /*********************************/
    }
  },
  
  created() {
    // 从缓存中恢复操作员对象
    let operatorSerial = localStorage.getItem('operator');
    if(operatorSerial==null || operatorSerial==undefined || operatorSerial=='') {
      // 返回登录页面
      this.$router.push('/');
      return;
    }
    this.operator = JSON.parse(operatorSerial);
    // 从缓存中恢复查询条件
    let sc = localStorage.getItem('sc.quickstat.etask');
    if(sc && sc.length>0) {
      let lsc = JSON.parse(sc);
      if(lsc.timestamp && (new Date().getTime() - lsc.timestamp) <= 30 * 60 * 1000) {
        this.searchCondition = lsc.data;
      } else {
        localStorage.removeItem('sc.quickstat.etask');
      }
    }
    // 初始化数据
    this.initApps();
    // 设置当日
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，+1
    const day = String(now.getDate()).padStart(2, '0');
    this.searchCondition.effectDate = year + '-' + month + '-' + day;
  },
  
  methods: {
    // 初始化应用
    async initApps(){
      // 清空当前集合数据
      this.apps = null;
      // 调用接口
      let res = await this.$api.apiCommonApps();
      // 应用数据存进data
      this.apps = res.content;
    },

    // 加载数据
    async loadData() {
      // 判断参数有效性
      if(!this.searchCondition.effectDate) {
        this.$message('效果数据日期必须选择',"warning");
        return;
      }
      if(!this.searchCondition.beforeHour) {
        this.$message('效果数据日期范围必须选择',"warning");
        return;
      }
      if(!this.searchCondition.channelSlotId) {
        this.$message('效果数据渠道号必须输入',"warning");
        return;
      }
      // 显示页面加载
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: 'Loading',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: '.box'//遮罩区域
      });
      // 获取请求参数
      let params = new Object();
      params['operatorId'] = this.operator.operatorId;
      params['effectDate'] = this.searchCondition.effectDate;
      params['beforeHour'] = this.searchCondition.beforeHour;
      params['appId'] = this.searchCondition.appId;
      params['appType'] = this.searchCondition.appType;
      params['channelSlotId'] = this.searchCondition.channelSlotId;
      params['userArpu'] = Math.floor(this.searchCondition.userArpu * 10000.0);
      params['userView'] = this.searchCondition.userView;
      params['userClick'] = this.searchCondition.userClick;
      // 清空当前集合数据
      this.effects = [];
      // 调用接口
      let res = await this.$api.apiQuickAppEtaskEffectList(params);
      if(res.result !== 1) {
        this.$message("加载数据列表失败","warning");
        // 加载结束
        loading.close();
        return;
      }
      // 应用数据存进data
      this.effects = res.content;
      // 加载结束
      loading.close();
    },
    
    // 搜索应用
    async onSearch(){
      // 保存查询条件
      localStorage.setItem('sc.quickstat.etask', JSON.stringify({
        'data': this.searchCondition,
        'timestamp': new Date().getTime()
      }));
      // 先清空原有数据
      this.effects = null;
      // 查询应用
      this.loadData();
    },

    // 回传
    async feedback(data) {
      // 验证参数有效性
      if(!data || !data.effect_time || !data.app_id || !data.app_type || !data.user_id || !data.session_id) {
        return;
      }
      // 显示页面加载
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: 'Loading',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: '.box'//遮罩区域
      });
      // 获取请求参数
      let params = new Object();
      params['operatorId'] = this.operator.operatorId;
      params['effectTime'] = data.effect_time;
      params['appId'] = data.app_id;
      params['appType'] = data.app_type;
      params['channelSlotId'] = data.channel_slot_id;
      params['sessionId'] = data.session_id;
      params['userId'] = data.user_id;
      params['userArpu'] = Math.floor(data.user_arpu * 1000000.0);
      params['userPrice'] = Math.floor(data.user_ecpm * 1000000.0);
      params['userView'] = data.user_view;
      params['userClick'] = data.user_click;
      params['userDuration'] = data.user_duration;
      // 调用接口
      let res = await this.$api.apiQuickAppEtaskEffectFeedback(params);
      if(res.result !== 1) {
        this.$message(res.message,"warning");
        // 加载结束
        loading.close();
        return;
      }
      // 提示成功
      this.$message("回传成功","success");
      // 加载结束
      loading.close();
    },

    /*************历史回传记录 ***************/

    async historyCallback() {
      this.dialogHistoryCallbackVisible = true;
      this.loadHistoryCallback();
    },

    async onCancelHistoryCallback() {
      this.dialogHistoryCallbackVisible = false;
    },

    async loadHistoryCallback() {
      // 显示页面加载
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: 'Loading',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: '.box'//遮罩区域
      });
      // 获取请求参数
      let params = new Object();
      params['operatorId'] = this.operator.operatorId;
      params['pageIndex'] = this.historyEtasks.pageIndex;
      params['pageSize'] = this.historyEtasks.pageSize;
      params['channelSlotId'] = this.searchCondition.channelSlotId;
      // 计算开始日期
      const now = new Date();
      const daysAgo = new Date(now);
      daysAgo.setDate(now.getDate() - this.historyEtasks.dateRange);    
      const year = daysAgo.getFullYear();
      const month = String(daysAgo.getMonth() + 1).padStart(2, '0'); // 月份从0开始，+1
      const day = String(daysAgo.getDate()).padStart(2, '0');
      params['etaskStartTime'] = year + '-' + month + '-' + day + ' 00:00:00'
      // 调用接口
      let res = await this.$api.apiQuickAppEtaskList(params);

      if(res.result !== 1) {
        this.$message("加载历史回传记录失败","warning");
        // 加载结束
        loading.close();
        return;
      }
      // 获取分页数据
      this.historyEtasks.pageIndex = res.content.pageIndex;
      this.historyEtasks.pageSize = res.content.pageSize;
      this.historyEtasks.pageCount = res.content.pageCount;
      this.historyEtasks.recordTotalCount = res.content.recordTotalCount;
      // 应用数据存进data
      this.historyEtasks.tableData = res.content.records;
      // 加载结束
      loading.close();
    },
    
    async changeOperateLogCurrPage(currPage) {
      this.historyEtasks.pageIndex = currPage;
      this.loadHistoryCallback();
    },

    async changeOperateLogPageSize(pageSize) {
      this.historyEtasks.pageSize = pageSize;
      this.historyEtasks.pageIndex = 1;
      this.loadHistoryCallback();
    },

    /***************************************/
  },
};

</script>
<style lang='scss' scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-wrap: nowrap;
  align-items: center;
  overflow: auto;
}
.work {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  overflow: auto;
}
.path {
  margin: 10px 5px 0px 15px;
  padding: 0px;
  width: 100%;
  height: 20px;
  color: rgb(6, 6, 31);
  font-size: 1rem;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
}
.path_img {
  margin-right:5px;
  height: 15px;
  width: 15px;
}
.path_txt {
  width: 100%;
  height: 20px;
  text-align: left;
}
.condition {
  margin: 10px 10px 10px 10px;
  padding: 5px 5px 5px 5px;
  width: 98%;
  height: auto;
  display: flex;
  flex-direction: row column;
  justify-content: flex-start;
  flex-wrap: wrap;
  background: #fff;
  border-radius: 9px;
  align-items: center;
}
.condi_line {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row column;
  background: #fff;
  border-radius: 9px;
  align-items: center;
}
.condi_item {
  margin-left: 30px;
  width: 240px;
  height: 36px;
  display: flex;
  align-items: center;
}
.condi_item_max {
  margin-left: 30px;
  width: 310px;
  height: 36px;
  display: flex;
  align-items: center;
}
.condi_item_label {
  text-align: left;
  width: 80px;
  font-size: 16px;
}
.condi_item_cnt {
  width: 160px;
  font-size: 16px;
}
.condi_item_cnt_max {
  width: 230px;
  font-size: 16px;
}
.condi_item_cnt .el-input {
  width: 160px;
}
.condi_item_cnt_max .el-input {
  width: 230px;
}
.condi_item_cnt .el-select {
  width: 160px;
}
.condi_item_cnt_max .el-select {
  width: 230px;
}
.condi_item_cnt .el-button {
  width: 160px;
}
.condi_item_cnt_max .el-date-picker {
  width: 230px;
}
.datalist {
  margin: 0px 10px 10px 10px;
  padding: 5px 5px 5px 5px;
  width: 98%;
  height: auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-direction: row;
  border-radius: 9px;
  overflow: auto;
  background: #fff;
}
.datalist .el-table {
  margin: 0 auto;
  width: 96%;
}
.dtlst_top {
  margin: 10px 10px 10px 15px;
  width: 96%;
  height: 25px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  align-items: center;
  background: #fff;
}
.dtlst_title {
  color: black;
  font-size: 1rem;
  font-weight: 500;
  height: 25px;
  text-align: left;
}
.dtlst_btn {
  height: 20px;
  width: calc(100% - 100px);
  text-align: right;
}
.dtlst_btn .el-button {
  margin: 0px 0px 0px 10px;
  padding: 0px 10px 0px 10px;
  color: white;
  background: #1890ff;
  height: 25px;
  min-width: 80px;
  width: auto;
}
.dtlst_table {
  width: 98%;
  height: auto;
}
.dtlst_operation {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.dtlst_pagination {
  margin: 0 auto;
  width: 96%;
  height: 25px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
</style>